"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_ID = void 0;
exports.WIDGET_ID = '144097ea-fea0-498e-ade7-e6de40127106';
//# sourceMappingURL=widget-id.js.map